import OurProductsPage from '@modules/professional/page/OurProductsPage';
import { loader } from '@modules/professional/page/loaders/our-products-page-loader.server';
import { prefetchProfessionalProductsImages } from '~/routes/_app.professional.$urlSegment.our-products.$';
import type { PreviewDisabledFeatures } from '@modules/root/hook/use-is-disabled-in-preview';
import { mergeMeta } from '~/modules/seo';
import { getRouteData } from '~/modules/root/util/get-route-data';
import type { APHandle } from '~/modules/root';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const { data, matches } = props;
        const { appData } = getRouteData(matches);
        const imageConfigProps = appData?.imageConfigProps;
        const isDesktop = data?.deviceType === 'desktop';
        const preloadImages = data?.searchResult?.hits
            ? prefetchProfessionalProductsImages(
                  data?.searchResult.hits,
                  isDesktop,
                  imageConfigProps
              )
            : [];
        return [...preloadImages];
    }
);

const disabledInPreview: PreviewDisabledFeatures = {
    featured_tile_links: false,
};

export const handle: APHandle = {
    category: 'product',
    excludedQuickSorts: [
        'uncategorised',
        'newlyCreated',
        'invalidLink',
        'highPrice',
        'lowPrice',
        'alphabetical',
        'updated',
    ],
    disabledInPreview,
};

export { loader };
export default OurProductsPage;
